import {
  Component,
  EventEmitter,
  Injector,
  Output,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ModalDirective } from 'ngx-bootstrap/modal';

export interface OverwriteDecision {
  date: Date;
  overwrite: boolean;
}
@Component({
  selector: 'overwriteAllocationDetailsConfirmModal',
  templateUrl: './overwrite-allocation-details-confirm-modal.component.html',
  styleUrls: ['overwrite-allocation-details-confirm-modal.component.less'],
})
export class OverwriteAllocationDetailsConfirmModalComponent extends AppComponentBase {
  @ViewChild('modal', { static: true }) modal: ModalDirective;
  options: any;

  @Output()
  copyAllocationWithOverwrite$: EventEmitter<OverwriteDecision> = new EventEmitter<OverwriteDecision>();

  constructor(injector: Injector) {
    super(injector);
  }

  show(options: any): void {
    this.options = options;
    this.modal.show();
  }
  close(): void {
    this.modal.hide();
  }

  copyWithoutOverwrite(): void {
    this.copy();
  }

  copyAndOverwrite(): void {
    this.copy(true);
  }

  private copy(overwrite: boolean = false): void {
    this.copyAllocationWithOverwrite$.emit({
      date: this.options,
      overwrite: overwrite,
    } as OverwriteDecision);
    this.modal.hide();
  }
}
